export class AggregationLevel {
}
AggregationLevel.ONE_MINUTE = 'minutes_1';
AggregationLevel.FIFTEEN_MINUTE = 'minutes_15';
AggregationLevel.ONE_HOUR = 'hours_1';
AggregationLevel.ONE_DAY = 'days_1';
AggregationLevel.values = {
    [AggregationLevel.ONE_MINUTE]: {
        title: '1 Minute',
        aggregationLevel: AggregationLevel.ONE_MINUTE,
    },
    [AggregationLevel.FIFTEEN_MINUTE]: {
        title: '15 Minutes',
        aggregationLevel: AggregationLevel.FIFTEEN_MINUTE,
    },
    [AggregationLevel.ONE_HOUR]: {
        title: '1 Hour',
        aggregationLevel: AggregationLevel.ONE_HOUR,
    },
    [AggregationLevel.ONE_DAY]: {
        title: '1 Day',
        aggregationLevel: AggregationLevel.ONE_DAY,
    },
};
export var Periods;
(function (Periods) {
    Periods["CURRENT_PERIOD"] = "currentPeriod";
    Periods["PREV_PERIOD"] = "prevPeriod";
})(Periods || (Periods = {}));
